<template>
  <div id="poster" :class="{'default': showBg}" >
    <div v-if="!showBg" class="poster_container">
      <img src="@/assets/img/capusta-logo-colored-special-compressed.svg" alt="capusta_logo" @click="$openLink(LANDING_URL)">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
import { LANDING_URL } from 'root/.env';

export default {
  name: 'Poster',
  mounted() {
    if (this.$slots.text) { this.showBg = false; }
  },
  data() {
    return { showBg: true, LANDING_URL };
  },
};
</script>

<style lang="sass" scoped>

#poster
  display: flex
    justify-content: center
  margin-top: 2.48rem
  margin-bottom: 2.48rem
  padding: 0.64rem

  +respond-to("cramped")
    padding-right: calc(.64rem + 1.48rem)
    padding-left: calc(.64rem + 1.48rem)

  +respond-to("small")
    padding-right: calc(.64rem + 3.36rem)
    padding-left: calc(.64rem + 3.36rem)

  +respond-to("small-medium")
    padding-right: calc(.64rem + 6.24rem)
    padding-left: calc(.64rem + 6.24rem)

  +respond-to("medium")
    flex-basis: 40%
    order: -1
    margin-top: 0
    margin-bottom: 0
    // padding: 6.24rem
    // padding-top: calc(.64rem + 24vh)
    padding-right: calc(.64rem + 3.36rem)
    padding-left: calc(.64rem + 3.36rem)
    text-align: left

    &.default
      display: flex
      align-content: center
      flex-wrap: wrap
      background-image: url("~@/assets/img/capusta-logo-colored-special-compressed.svg")
      background-repeat: no-repeat
      background-position: center
      background-size: 60%

  +respond-to("large")
    flex-basis: 50%
    justify-content: center

    &.default
      background-position: right 6.24rem center
      background-size: 32rem

  .poster_container
    display: flex
    flex-direction: column
    justify-content: center
    width: 100%

    img
      display: none
      cursor: pointer

    +respond-to("medium")
      img
        position: relative
        top: -100px
        display: block

    +respond-to("large")
      width: 45%

    +respond-to("extended")
      width: 35%

  h1
    font-size: 1.12rem

    small
      font-weight: lighter

    time
      font-size: smaller
      font-weight: lighter

  p
    margin-top: 1.24rem

    a
      display: inline
      text-decoration: underline

      &:after
        display: none

    span
      font-weight: 600

  a
    text-align: left
    color: $soft-white

    &:hover
      color: $pure-white

    &::after
      +pseudo-block

      right: 0
      bottom: 0
      left: -2px
      width: calc(100% + 4px)
      height: 0.08rem
      background: $medium-purple

</style>
